import axios from 'axios';

import { authHeader } from '../_helpers';
import { urlAPI } from './index';

// ruta API de la entidad
let API = 'api/image/';

// Exporta metodos
export const imageService = {
    getAll,
    putObject,
    postObject,
    deleteObject
};

// Lee todos los elementos
async function getAll(folder) {
    return axios.get(urlAPI + API + "thumbnails/" + folder, authHeader()).then(registro => {
        return registro.data;
    });
}

// Post de la entidad
function postObject(payload) {
    alert(urlAPI + API + "upload-file");
    return axios.post(urlAPI + API + "upload-file", payload, authHeader()).then(registro => {
        return registro.data;
    });
}

// put de la entidad
function putObject(obj) {
    // Copiar todas las propiedades
    var modelo = {
        id: obj.id,
        nombre: obj.nombre,
        borrado: obj.borrado
    };
    return axios
        .put(urlAPI + API + modelo.id, modelo, authHeader())
        .then(registro => {
            return registro.data;
        });
}

// delete de la entidad
function deleteObject(obj) {
    return axios.delete(urlAPI + API + obj.domain + '/' + obj.image, obj.payload, authHeader()).then(registro => {
        return registro.data;
    });
}
